:host {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: absolute;
  contain: layout size style;
  overflow: hidden;
  z-index: 0;
}